// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerCreateNote_ri_vT{
    display: flex;
    align-items: center;
    gap: 5px;

}
.tag_qnia_ {
  text-align: center;
  color: var(--white-color);
  width: fit-content;
  border-radius: 999px;
  display: block;
  height: 20px;
  width: 20px;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  -ms-border-radius: 999px;
  -o-border-radius: 999px;
  cursor: pointer;
}

.tagWhite_olXpJ {
    background-color: var(--white-background);
  }
  .tagRed_AzdDt {
    background-color: var(--f2c6c2-background);
  }
  .tagOrange_eNh0V {
    background-color: var(--f2cfc2-background);
  }
  .tagYellow_NJrdM {
    background-color: var(--f2e3c2-background);
  }
  .tagGreen_JXrQq {
    background-color: var(--_c2f2d3-background);
  }
  .tagBlue_D0v1s {
    background-color: var(--c2d8f2-background);
  }
  .tagViolet_YTXzt {
    background-color: var(--d7c5f6-background);
  }
  .tagPink_jd9Kn {
    background-color: var(--f0c2f2-background);
  }
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/CreateNote/CreateNote.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;;AAEZ;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;IACI,yCAAyC;EAC3C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C","sourcesContent":[".headerCreateNote{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n\n}\n.tag {\n  text-align: center;\n  color: var(--white-color);\n  width: fit-content;\n  border-radius: 999px;\n  display: block;\n  height: 20px;\n  width: 20px;\n  -webkit-border-radius: 999px;\n  -moz-border-radius: 999px;\n  -ms-border-radius: 999px;\n  -o-border-radius: 999px;\n  cursor: pointer;\n}\n\n.tagWhite {\n    background-color: var(--white-background);\n  }\n  .tagRed {\n    background-color: var(--f2c6c2-background);\n  }\n  .tagOrange {\n    background-color: var(--f2cfc2-background);\n  }\n  .tagYellow {\n    background-color: var(--f2e3c2-background);\n  }\n  .tagGreen {\n    background-color: var(--_c2f2d3-background);\n  }\n  .tagBlue {\n    background-color: var(--c2d8f2-background);\n  }\n  .tagViolet {\n    background-color: var(--d7c5f6-background);\n  }\n  .tagPink {\n    background-color: var(--f0c2f2-background);\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerCreateNote": `headerCreateNote_ri_vT`,
	"tag": `tag_qnia_`,
	"tagWhite": `tagWhite_olXpJ`,
	"tagRed": `tagRed_AzdDt`,
	"tagOrange": `tagOrange_eNh0V`,
	"tagYellow": `tagYellow_NJrdM`,
	"tagGreen": `tagGreen_JXrQq`,
	"tagBlue": `tagBlue_D0v1s`,
	"tagViolet": `tagViolet_YTXzt`,
	"tagPink": `tagPink_jd9Kn`
};
export default ___CSS_LOADER_EXPORT___;
